<app-navigation tagline="GESCHAFFT" marginLeftClass="ml-50"></app-navigation>
<ion-content style="background-color: #fff">
  <div class="ion-margin slide">
    <div class="ion-padding">
      <p>Das war es schon mit den <span class="highlight">Fragen!</span></p>

      <p>
        Wir hoffen, wir haben Dich etwas zum <b>Nachdenken</b> gebracht und mit dem einen oder anderen <b>Vorurteil</b> gegenüber Studium und Ausbildung aufgeräumt. Im besten Fall hat es auch etwas Spaß gemacht.
      </p>
      <app-buttons (clickedNext)="nextButtonHandler()" [showLastButton]="false">
      </app-buttons>
    </div>
  </div>
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-title class="footer">#ORIENTANDO</ion-title>
  </ion-toolbar>
</ion-footer>
